
export function handleAxiosError(error) {
  if (error.response) {
    const data = error.response.data;
    if (typeof data === "string") {
      return data;
    }
    if (data?.message) {
      return data.message;
    }
    if (data?.error) {
      return data.error;
    }
    return `Request failed (${error.response.status})`;
  }
  if (error.request) {
    return "Network error. No response from server.";
  }
  return error.message || "Unexpected error occurred";
}
